module.exports = __webpack_public_path__ + "twitternewlogo.svg";